/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import moment from 'moment';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import _ from 'lodash';
import { useBreadcrumb } from '../../contexts/BreadcrumbContext';
import { MotionContainer } from '../../components/MotionContainer';
import { Loading } from '../../components/Loading';
import { buildPieChart } from './charts/pie';
import { Body, Cell, Footer, Head, Row, Table } from '../../components/Table';
import { usePathParams } from '../../hooks/useParams';
import convertOffsetToPage from '../../utils/offsetToPage';
import Pagination from '../../components/TablePagination';
import { DAY_IN_MS, DatePicker } from '../../components/DatePicker';

export function FlowsDashboardPage({ history }) {
  const { setPaths } = useBreadcrumb();
  const intl = useIntl();
  const { id } = useParams();
  const [isLoading, setLoading] = useState(false);
  const [executions, setExecutions] = useState([]);
  const chartRef = useRef();
  const datePickerRef = useRef();
  const { queryParams, setQueryParams } = usePathParams('', 10);
  // const { user } = useSelector((state) => state.auth)

  useEffect(() => {
    const initialDate = new Date(Date.now() - DAY_IN_MS).toISOString();
    const endDate = new Date().toISOString();
    const filters = `?${new URLSearchParams({
      initialDate,
      endDate,
    })}`;
    getData(filters);
  }, []);

  useEffect(() => {
    setPaths([
      {
        title: intl.formatMessage({ id: 'MENU.DASHBOARD' }),
        pathname: `/dashboard`,
      },
      id ? { title: 'Flows', pathname: '/dashboard/flows' } : {},
    ]);
  }, [id]);

  async function getData(filters) {
    try {
      setLoading(true);
      console.log(filters);
      const { data } = await axios.get(`/flows-executions${filters}`);
      if (data) {
        console.log(data);
        const a = [
          { executionStatus: 'SUCCESS' },
          { executionStatus: 'SUCCESS' },
          { executionStatus: 'SUCCESS' },
          { executionStatus: 'SUCCESS' },
          { executionStatus: 'SUCCESS' },
          {
            executionStatus: 'FAILED',
            executionDate: '2024-06-19T17:13:37.092Z',
            message: 'An error description',
          },
          {
            executionStatus: 'FAILED',
            executionDate: '2024-06-19T17:12:37.092Z',
            message: 'An error description',
          },
          {
            executionStatus: 'FAILED',
            executionDate: '2024-06-19T17:11:37.092Z',
            message: 'An error description',
          },
        ];
        setExecutions(a);
        buildPieChart(chartRef.current, buildPieChartData(a));
      }
    } finally {
      setLoading(false);
    }
  }

  const buildPieChartData = history => {
    const historyGroup = _.groupBy(history, 'executionStatus');
    return _.map(_.keys(historyGroup), function(e) {
      return _.reduce(
        historyGroup[e],
        function(r, o) {
          return (r.value += 1), r;
        },
        {
          id: e,
          value: 0,
          name: historyGroup[e][0].executionStatus,
        }
      );
    });
  };

  const handleDateSelection = async (initialDate, endDate) => {
    const filters = `?${new URLSearchParams({
      initialDate,
      endDate,
    })}`;
    getData(filters);
  };

  const failedExecutions = useMemo(() => {
    return executions.filter(exec => exec.executionStatus === 'FAILED');
  }, [executions]);
  const slicedFailedExecutions = failedExecutions.slice(
    queryParams.offset,
    queryParams.offset + queryParams.limit
  );

  return (
    <MotionContainer className="card">
      <Loading isLoading={isLoading} />
      <div className="card-body">
        <DatePicker
          ref={datePickerRef}
          intl={intl}
          onDateSelected={handleDateSelection}
          classes="temperature-date-picker"
        />
        <div style={{ minHeight: 300 }} ref={chartRef}></div>
        <div className="flex-1">
          <Table className="mt-3">
            <Head>
              <Cell className="font-weight-normal" width={'20%'}>
                {' '}
                {intl.formatMessage({ id: 'STATUS' })}{' '}
              </Cell>
              <Cell className="font-weight-normal" width={'50%'}>
                {' '}
                {intl.formatMessage({ id: 'REASON' })}{' '}
              </Cell>
              <Cell className="font-weight-normal" width={'30%'}>
                {' '}
                {intl.formatMessage({ id: 'EXECUTION_DATE' })}{' '}
              </Cell>
            </Head>
            <Body>
              {slicedFailedExecutions.map((exec, index) => (
                <Row key={index}>
                  <Cell>{exec.executionStatus}</Cell>
                  <Cell>{exec.message}</Cell>
                  <Cell>
                    {moment(exec.executionDate).format('DD MMM YYYY hh:mm:ssa')}
                  </Cell>
                </Row>
              ))}
            </Body>
            <Footer>
              <Row>
                <Pagination
                  rowsPerPageOptions={[5, 10, 15, 20]}
                  count={failedExecutions.length}
                  rowsPerPage={queryParams.limit}
                  page={convertOffsetToPage(
                    queryParams.offset,
                    queryParams.limit
                  )}
                  onChangePage={(_, val) => {
                    setQueryParams(state => ({
                      ...state,
                      offset: val,
                    }));
                  }}
                  className="no-padding"
                  onChangeRowsPerPage={e =>
                    setQueryParams(state => ({
                      ...state,
                      limit: +e.target.value,
                      offset: 0,
                    }))
                  }
                />
              </Row>
            </Footer>
          </Table>
        </div>
      </div>
    </MotionContainer>
  );
}
